import { OnboardingProTask } from '@weave/schema-gen-ts/dist/shared/call-intelligence/plg/onboarding.pb';
import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';

export interface ProOnboardingActionEligibility {
  hasSentimentDrilldownTarget: boolean;
  hasEligibleCallInsightPanel: boolean;
  hasEligiblePatientContextCall: boolean;
  hasEligibleFollowUpTasks: boolean;
}

interface ProOnboardingActionStore {
  pendingTask: OnboardingProTask | null;
  isEligibilityResolved: boolean;
  eligibility: ProOnboardingActionEligibility;
  setPendingTask: (task: OnboardingProTask) => void;
  clearPendingTask: () => void;
  setEligibility: (eligibility: Partial<ProOnboardingActionEligibility>) => void;
}

export const useProOnboardingActionStore = createStoreWithSubscribe<ProOnboardingActionStore>(
  (set) => ({
    pendingTask: null,
    isEligibilityResolved: false,
    eligibility: {
      hasSentimentDrilldownTarget: true,
      hasEligibleCallInsightPanel: true,
      hasEligiblePatientContextCall: true,
      hasEligibleFollowUpTasks: true,
    },

    setPendingTask: (task) => {
      set(
        (state) => {
          state.pendingTask = task;
          state.isEligibilityResolved = false;
        },
        false,
        { type: 'SET_PRO_PENDING_TASK' }
      );
    },

    clearPendingTask: () => {
      set(
        (state) => {
          state.pendingTask = null;
        },
        false,
        { type: 'CLEAR_PRO_PENDING_TASK' }
      );
    },

    setEligibility: (eligibility) => {
      set(
        (state) => {
          state.eligibility = {
            ...state.eligibility,
            ...eligibility,
          };

          state.isEligibilityResolved = true;
        },
        false,
        { type: 'SET_PRO_ELIGIBILITY' }
      );
    },
  }),
  { name: 'ProOnboardingActionStore', trace: true }
);

export const useProOnboardingActionShallowStore = createShallowStore(useProOnboardingActionStore);
